import dayjs from 'dayjs';

export const formatDateToMonthDayAndTime = (isoDateStr: string) => {
  return dayjs(isoDateStr).format('MMM D, YYYY · HH:mm A');
};

export const formatDateToShortMonthDayYear = (isoDateStr: string) => {
  return dayjs(isoDateStr).format('MMM DD, YYYY');
};
